<div
  class="d-inline-block no-caret"
  ngbDropdown
  #moreActionsDropdown="ngbDropdown"
  container="body">
  <button
    cpGTagEvent
    [params]="{event_label: 'more_payroll_actions_dropdown'}"
    class="btn"
    id="moreActionsDropdown"
    ngbDropdownAnchor
    (click)="moreActionsDropdown.open()">
    ...
  </button>
  <div ngbDropdownMenu aria-labelledby="moreActionsDropdown">
    <button
      ngbDropdownItem
      (click)="openPaylineDetails(params)"
      cpGTagEvent
      [params]="{event_label: 'more_actions_view_edit_payline'}">
      View/Edit Pay
    </button>
    <button
      ngbDropdownItem
      (click)="addPayline()"
      cpGTagEvent
      [params]="{event_label: 'more_actions_add_payline'}">
      Add New Pay
    </button>
    <button
      *ngIf="canViewPeople"
      ngbDropdownItem
      (click)="openPersonModal()"
      cpGTagEvent
      [params]="{event_label: 'more_actions_add_person'}">
      View/Edit Person
    </button>
  </div>
</div>
